import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ClientItemId } from 'owa-client-ids';
import { lazyForwardMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { InstrumentationContext, mailStore } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import Item from 'owa-service/lib/contract/Item';
import { lazyAllowResponseForSmimeItem } from 'owa-smime';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-analytics-actions';

export default action('forwardItem')(async function forwardItem(
    itemId: ClientItemId,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    suppressServerMarkReadOnReplyOrForward: boolean
) {
    const restrictionToConfirm = <IRMRestrictions>{ ForwardAllowed: true };
    const item: Item = mailStore.items.get(itemId.Id);
    const isResponseAllowedForSmimeItem =
        !isSMIMEItem(item) ||
        (await (await lazyAllowResponseForSmimeItem.import())(
            itemId.Id,
            strings.itemHeaderForward
        ));

    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(strings.irm_actionNotAllowedOnThisItem, strings.itemHeaderForward)
        ) &&
        isResponseAllowedForSmimeItem
    ) {
        lazyForwardMessage.importAndExecute(
            itemId,
            actionSource,
            instrumentationContexts,
            suppressServerMarkReadOnReplyOrForward
        );
        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
